module.exports = new __parcel__URL__(require('./helpers/bundle-manifest').resolve("k547Y")).toString();